import { FC } from 'react';

import {
  Form,
  Button,
  SpaceBetween,
  FormField,
  Textarea
} from '@awsui/components-react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { IRejectUserWorkSpaceDecommissionRequest } from '../../../../../interfaces/workSpaces/userWorkSpaceDecommissionRequest';

interface ViewProps {
  handleSubmittedForm: (
    data: IRejectUserWorkSpaceDecommissionRequest
  ) => Promise<void>;
  formValues: IRejectUserWorkSpaceDecommissionRequest;
}

const View: FC<ViewProps> = ({ formValues, handleSubmittedForm }) => {
  const validationSchema = yup.object({
    rejectionReason: yup.string().required()
  });

  return (
    <Formik
      validateOnChange={true}
      initialValues={formValues}
      validationSchema={validationSchema}
      onSubmit={(data, { setSubmitting, resetForm }) => {
        setSubmitting(true);

        handleSubmittedForm(data).then((resp) => {
          resetForm();
          setSubmitting(false);
        });
      }}
    >
      {({ values, errors, isSubmitting, setFieldValue, handleSubmit }) => (
        <SpaceBetween direction="vertical" size="xs">
          <Form
            actions={
              <Button
                variant="primary"
                onClick={() => handleSubmit()}
                disabled={isSubmitting}
              >
                Submit
              </Button>
            }
          >
            <SpaceBetween direction="vertical" size="xs">
              <FormField
                label="Rejection Reason"
                errorText={errors.rejectionReason}
              >
                <Textarea
                  value={values.rejectionReason}
                  onChange={({ detail }) =>
                    setFieldValue('rejectionReason', detail.value)
                  }
                  invalid={!!errors.rejectionReason}
                />
              </FormField>
            </SpaceBetween>
          </Form>
        </SpaceBetween>
      )}
    </Formik>
  );
};
export default View;
